export const REFERRAL_COOKIE_NAME = '_mm_ref_id';
export const PAP_REFERRAL_COOKIE_NAME = '_pap_ref_code';
export const PAP_QUERY_PARAM_EXPRESSION = /a_aid=([^&]+)/;
export const AFFILIATE_QUERY_PARAMS_EXPRESSION = /ref=([^&]+)/;
// default image banner in PAP used for impressions tracking
export const PAP_BANNER_ID = 11110001;
// PAP docs tell us the url is not necessarily static but it does work in production
export const PAP_IMPRESSIONS_TRACKING_PATH = 'scripts/imp.php/';
export const PAP_BANNER_QUERY_PARAM = 'a_bid';
export const PAP_AFFILIATE_QUERY_PARAM = 'a_aid';
